import { render, staticRenderFns } from "./LoginShell.vue?vue&type=template&id=1a340125&scoped=true"
import script from "./LoginShell.vue?vue&type=script&lang=js"
export * from "./LoginShell.vue?vue&type=script&lang=js"
import style0 from "./LoginShell.vue?vue&type=style&index=0&id=1a340125&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a340125",
  null
  
)

export default component.exports